"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgShareOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.5 19a4.5 4.5 0 00-3.41 1.59L11.88 17a4.14 4.14 0 000-2l7.21-3.6A4.48 4.48 0 1018 8.5a4.67 4.67 0 00.16 1.13L11 13.21a4.5 4.5 0 100 5.58l7.15 3.58A4.67 4.67 0 0018 23.5a4.5 4.5 0 104.5-4.5zm0-13A2.5 2.5 0 1120 8.5 2.5 2.5 0 0122.5 6zm-15 12.5A2.5 2.5 0 1110 16a2.5 2.5 0 01-2.5 2.5zm15 7.5a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z" })));
}
exports.default = SvgShareOutline;
//# sourceMappingURL=ShareOutline.js.map